// import React, {useEffect} from 'react'
// import './css/LoginPage.css'
// import {Link, useHistory} from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";
// import useHeaderOps from "../hooks/useHeaderOps";
// //import {version} from "../../../package.json";
// import {emptyCache} from "../../lib/js/jsUtil";
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from "axios";
// import packageInfo from "../../../package.json";




// {  /*
//     THIS WAS WRITTEM FOR BYPASS LOGIN
//     export default function LoginPage() {
//     const history = useHistory();

//     useEffect(() => {
//           Redirect the user to the dashboard
//           history.push("/dashboard");
//         }, []);

//     return null; // This component doesn't render anything
// */}



// export default function LoginPage(props) {

//     // used for redirection:
//     const history = useHistory()

//     // used for login related operations
//     const loginOps = useLoginOps(props)

//     // used for header related operations
//     const headerOps = useHeaderOps(props)


//     useEffect(()=>{
//         // if user is logged in
//         if(props.loginDetails!==null) {

//             // & projects are not set:
//              if(props.userProjects===null) {
//             //      fetch projects & activities of user
//                  // avoid, infinite try on dashboard while fail to fetch project/activities
//                  loginOps.fetchProjectsAndActivities()
//              } else {    // project & activities of user are set
//                // goto dashboard
//                 history.push("/dashboard")
//          }
//         }
//         // above operation happen when, login details or user projects are changed:
//     },[props.loginDetails,props.userProjects])

//     // using references to get email & password at login time. These refs are being
//     // used with HTML elements.
//     const emailInput = React.createRef()
//     const passInput = React.createRef()


//     // adding css 'login' class for custom css on this page
//     useEffect(()=>{
//         // setup (add)
//         document.body.classList.add("login")

//         // return function will execute when we move
//         // from login page to some other page
//         return ()=>{
//             // tear down (remove)
//             document.body.classList.remove("login")
//         }
//     })

//     const tryWithoutLogin = ()=> {
//         // set free activity related details in header data
//         headerOps.setFreeActivityHeader()
//         // open free-activity page
//         history.push("/free-activity")
//     }
    
    

    
//     // login/signUp using google auth


//     const googleAuthLogin = useGoogleLogin({
//         onSuccess: async respose => {
//             try {
//                 const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
//                     headers: {
//                         "Authorization": `Bearer ${respose.access_token}`
//                     }
//                 })
//                 // console.log(res.data, "email: ", res.data.email)
//                 if(res.data.email_verified){
//                     loginOps.loginUserGoogle(res.data.email)
//                 }
//                 else{
//                     props.toastSuccess("Error during Google signIn/Out, please try again")
//                 }
//             } catch (err) {
//                 // console.log(err)
//                 props.toastSuccess("Error during Google signIn/Out, please try again")
//             }
//         }
//     });

//     // when user click login
//     function handleLoginClick() {
//         // perform login operation:
//         loginOps.loginUser(emailInput.current.value,passInput.current.value)
//     }

//     function onClickCreateAccount() {
//         window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true","_blank")
//         // history.push("/signup-41251234123")
//     }

//     function onClickForgotPassword() {
//         // forget password feature will be available when email sending issue with https is fixed.
//         // alert("Password reset feature will be available soon.")

//         history.push("/forget-password")

//     }



//     // For : Test caching:
//     // useEffect(()=>{
//     //     props.toastInfo("Testing Cache Burst. Serial 2311321__4")
//     // })

//     // cache burst when user comes on login page:
//     useEffect(()=>{
//         async function fetchVersion() {
//             const cacheBurst = new Date().getTime()

//             let result = await fetch(`${process.env.PUBLIC_URL}/meta.json?`+cacheBurst)
//             result = await result.json()
//             const oldVersion = packageInfo.version
//             const newVersion = result.version
//             if(oldVersion!==newVersion) {
//                 props.set_appVersion(result.version)
//                 emptyCache()
//             }
//         }
//         fetchVersion().then()
//     },[])




//     return (
//         <>
//             <header id="home-section">
//                 <div className="container-fluid h-100">
//                     <div className="row h-100">
//                         {/* process.env.PUBLIC_URL = points to the public directory of the project. */}
//                         <div className="col-lg-8 p-0 text-white cover_img" style={{backgroundImage:'url('+process.env.PUBLIC_URL + '/assets/images/web/geometric-1732847_960_720.webp)'}}>
//                             <div className="dark-overlay d-flex flex-column align-items-center justify-content-center">
//                                 <h1 className="display-4 my-5 mont_txt">AI Connect</h1>

//                                 <div id="slider4" className="container carousel slide mb-5" data-ride="carousel">
//                                     <ol className="carousel-indicators">
//                                         <li className="active" data-target="#slider4" data-slide-to="0"/>
//                                         <li data-target="#slider4" data-slide-to="1"/>
//                                         <li data-target="#slider4" data-slide-to="2"/>
//                                         <li data-target="#slider4" data-slide-to="3"/>
//                                     </ol>

//                                     {/* Moving Slider on Login Page  */}
//                                     <div className="carousel-inner">
//                                         <div className="carousel-item active">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">Graphics
//                                                         Designing</h2>
//                                                     <ul className="desc2 p-3 mt-3 ml-3 poppins_txt">
//                                                         <li> Block based coding to learn Graphics Designing.</li>
//                                                         <li> Learn Block Coding & Python Coding.</li>
//                                                         <li> 50 + Graphics Designing Activities, more than 25 + Graphics
//                                                             Designing Projects.
//                                                         </li>
//                                                         <li> Draw your Imaginations & learn coding.</li>
//                                                         <li> Think Out of the box & draw your own graphics.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/Graphics_Designing.png' }
//                                                          alt={"Graphics_Designing"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="carousel-item">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">Basic
//                                                         Python</h2>
//                                                     <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
//                                                         <li> GUI based coding to learn Python Coding.</li>
//                                                         <li> Learn Block Coding & Python Coding.</li>
//                                                         <li> 100 + Basic Python Activities, more than 50 + Basic Python
//                                                             Projects.
//                                                         </li>
//                                                         <li> Draw your Imaginations & learn coding.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/Basic_Python.png' }
//                                                          alt={"Basic_Python"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="carousel-item">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">Machine
//                                                         Learning</h2>
//                                                     <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
//                                                         <li> Train your own machine.</li>
//                                                         <li> Test & Develop cases for your machine.</li>
//                                                         <li> Deploy your own predictive learning.</li>
//                                                         <li> Learn Block Coding & Python Coding.</li>
//                                                         <li> 50 + Machine Learning projects.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/Machine_Learning.png' }
//                                                          alt={"Machine_Learning"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="carousel-item">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">AI Real
//                                                         World</h2>
//                                                     <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
//                                                         <li> Learn to detect & recognize human faces.</li>
//                                                         <li> Learn to recognize objects.</li>
//                                                         <li> Learn to recognize color & many more.</li>
//                                                         <li> Integration of AI with hardware .</li>
//                                                         <li> 50 + Artificial Intelligence projects.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/AI_Real_World.png' }
//                                                          alt={"AI_Real_World"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                     </div>


//                                     <a href="#slider4" className="carousel-control-prev" data-slide="prev">
//                                         <span className="carousel-control-prev-icon"/>
//                                     </a>

//                                     <a href="#slider4" className="carousel-control-next" data-slide="next">
//                                         <span className="carousel-control-next-icon"/>
//                                     </a>
//                                 </div>


//                             </div>
//                         </div>


//                         <div className="col-lg-4 d-flex flex-column align-items-center justify-content-center"
//                              style={{backgroundColor: "White" }}>
//                             {/* <img id="com_logo" src={process.env.PUBLIC_URL + '/assets/images/web/stemrobo_logo.png' } className="img-fluid mt-5 mb-3"
//                                  width="220px" alt={"stemrobo_logo"}/> */}

//                             <img
//                              id="com_logo"
//                              src={process.env.PUBLIC_URL + '/assets/images/web/stemrobo_logo.png'}
//                              className="img-fluid mt-5 mb-3"
//                              style={{ width: '280px', height: 'auto' }}
//                              alt={"stemrobo_logo"}
//                             />



//                             <form>
//                                 <h3 className="text-center ai_h2 my-5">Login to Continue</h3>
//                                 <div className="input-group mb-3">
//                                     <div className="input-group-prepend">
//                                         <span className="input-group-text">@</span>
//                                     </div>
//                                     <input className="form-control mont_input1" name="email" type="email"
//                                            maxLength="150"
//                                            placeholder="Email-Id"
//                                            ref={emailInput}
//                                         // value={"ankit.kumar@tevatrontech.org"}
//                                     />
//                                 </div>

//                                 <div className="input-group mb-3">
//                                     <div className="input-group-prepend">
//                                         <span className="input-group-text"><i className="fa fa-lock" /> </span>
//                                     </div>
//                                     <input className="form-control mont_input1" name="password" type="password"
//                                            maxLength="50"
//                                            placeholder="Password"
//                                            ref={passInput}
//                                         // value={"md5pass"}
//                                     />
//                                 </div>
//                                 <div className="d-flex px-3">
//                                     <div className="checkbox mr-auto invisible">
//                                     </div>
//                                     <span id="frgt_pass" onClick={ onClickForgotPassword } className="btn-link mont_txt txt_sm" style={{cursor: "pointer" }}>Forget Password?</span>
//                                 </div>


//                                 {/* Remove below div, when create account is enabled. */}

//                                 {/*<div className="d-flex justify-content-around my-5">*/}
//                                 {/*    <button id="btn_login" className="bt1 btn btn-primary" type="button" onClick={ handleLoginClick }>Login</button>*/}
//                                 {/*</div>*/}

//                                 <div className="btn-toolbar justify-content-between" role="toolbar"
//                                      aria-label="Toolbar with button groups">
//                                     <div className="btn-group" role="group" aria-label="First group">
//                                         <div className="d-flex justify-content-around-1 my-4">
//                                             <button id="btn_login" className="bt1 btn btn-primary" type="button" onClick={ handleLoginClick }>Login</button>
//                                         </div>
//                                     </div>
//                                     <div className="input-group">
//                                         <div className="d-flex justify-content-around my-4">
//                                             <button id="btn_login" style={{'background-color':'green','color':'white'}} className="bt1 btn btn-light" type="button" onClick={ onClickCreateAccount }>Request a Callback</button>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div class="hr-div">
//                                     <hr class="hr-two-divider" style={{ "margin": "24px 0px" }}></hr>
//                                     <div class="hr-middle-text">or</div>
//                                     <hr class="hr-two-divider" style={{ "margin": "24px 0px" }}></hr>
//                                 </div>

                                
//                                     <div className="d-flex justify-content-around my-3">
//                                     <button id="btn_google_login" className="bt1 btn btn-primary btn-transparent" type="button" onClick={googleAuthLogin}>
//                                     <img style={{height: "1.5rem", marginBottom: "0.2rem"}} src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'}/>  Continue with google
//                                     </button>
//                                 </div>
//                                 <hr /> 
//                             </form>
//                             <br/>
//                             <Link onClick={ tryWithoutLogin } className="mb-5">Try without login &rarr;</Link>
//                         </div>
//                     </div>
//                 </div>
//             </header>
//         </>
//     )
// }




// FOR SAML


// import React, {useEffect, useState} from 'react'
// import './css/LoginPage.css'
// import {Link, useHistory, useLocation} from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";
// import useHeaderOps from "../hooks/useHeaderOps";
// import {emptyCache} from "../../lib/js/jsUtil";
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from "axios";
// import packageInfo from "../../../package.json";

// export default function LoginPage(props) {
//     const history = useHistory()
//     const location = useLocation()
//     const loginOps = useLoginOps(props)
//     const headerOps = useHeaderOps(props)
//     const [testUserId, setTestUserId] = useState('691eb1044bce047d10c2f4fa') // Your test user ID

//     // SAML handling - runs on every location change
//     useEffect(() => {
//         console.log('🔍 [DEBUG] Location changed:', location.pathname);
//         console.log('🔍 [DEBUG] Full URL:', window.location.href);
//         handleSAMLRedirect();
//     }, [location.pathname]);

    

//     useEffect(() => {
//         console.log('🔍 [DEBUG] LoginPage mounted - checking authentication status');
//         console.log('🔍 [DEBUG] Props.loginDetails:', props.loginDetails);
        
//         // Existing logic for normal login
//         if(props.loginDetails !== null) {
//             console.log('🔍 [DEBUG] User already logged in, checking projects...');
//             if(props.userProjects === null) {
//                 loginOps.fetchProjectsAndActivities()
//             } else {
//                 console.log('🔍 [DEBUG] Redirecting to dashboard from existing login');
//                 history.push("/dashboard")
//             }
//         } else {
//             console.log('🔍 [DEBUG] User not logged in, showing login form');
//         }
//     }, [props.loginDetails, props.userProjects])

  
// // Handle SAML redirect
// const handleSAMLRedirect = async () => {
//     const currentPath = window.location.pathname;
//     console.log('🔍 [DEBUG] Checking SAML redirect for path:', currentPath);
    
//     // ADD STRICTER CHECKS:
//     // 1. Only process if we're NOT already on dashboard
//     // 2. Only process if path exactly matches SAML pattern
//     if (currentPath === '/dashboard' || props.loginDetails !== null) {
//         console.log('🔍 [DEBUG] Already on dashboard or logged in, skipping SAML redirect');
//         return;
//     }
    
//     // Check for /dashboard/user_id pattern
//     // if (currentPath.startsWith('/dashboard/')) {
//     // ONLY process SAML when loginDetails is null AND route contains userId
// if (props.loginDetails === null && currentPath.startsWith('/dashboard/')) {

//         const userId = extractUserIdFromPath(currentPath);
        
//         if (userId) {
//             console.log('✅ [DEBUG] Found user ID in dashboard path:', userId);
//             await processSAMLUserLogin(userId);
//         } else {
//             console.log('🔍 [DEBUG] No valid user ID found in dashboard path');
//         }
//     } else {
//         console.log('🔍 [DEBUG] Not a SAML redirect path, skipping');
//     }
// }



    

//     // Extract user ID from path
//     const extractUserIdFromPath = (path) => {
//         console.log('🔍 [DEBUG] Extracting user ID from path:', path);
        
//         const pathParts = path.split('/');
        
//         if (pathParts.length >= 3 && pathParts[1] === 'dashboard') {
//             const userId = pathParts[2];
            
//             if (/^[0-9a-fA-F]{24}$/.test(userId)) {
//                 console.log('✅ [DEBUG] Valid user ID extracted:', userId);
//                 return userId;
//             }
//         }
        
//         return null;
//     }

//     // Process SAML login with user ID
//    // Process SAML login with user ID
// // Process SAML login with user ID
// const processSAMLUserLogin = async (userId) => {
//     try {
//         console.log('🚀 [DEBUG] Starting SAML login process with ID:', userId);
        
//         const response = await fetch('http://localhost:35878/restapi/verifySamlToken', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ id: userId })
//         });

//         console.log('🔍 [DEBUG] Response status:', response.status);

//         if (!response.ok) {
//             throw new Error(`API returned status: ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('🔍 [DEBUG] Full response data:', data);

//         // Add proper null checking here
//         if (data.is_loggedin === true && data.user && data.user.token) {
//             console.log('✅ [DEBUG] User verified successfully');
//             await handleSAMLUserLogin(data.user);
//         } else {
//             console.error('❌ [DEBUG] User verification failed - missing data:', {
//                 is_loggedin: data.is_loggedin,
//                 hasUser: !!data.user,
//                 hasToken: data.user ? !!data.user.token : 'no user data'
//             });
//             throw new Error('User verification failed - missing token or user data');
//         }

//     } catch (error) {
//         console.error('❌ [DEBUG] SAML processing failed:', error);
//         props.toastSuccess('SSO login failed. Please try regular login.');
//     }
// }

 
// const handleSAMLUserLogin = async (userData) => {
//     try {
//         console.log('🔍 [DEBUG] Handling SAML user login:', userData);

//         // 1️⃣ Strong validation of user data
//         if (
//             !userData || 
//             typeof userData !== "object" ||
//             !userData.token ||
//             !userData.email ||
//             !userData._id
//         ) {
//             console.error("❌ [DEBUG] Invalid or incomplete SAML user data:", userData);
//             return;
//         }

//         console.log('🔍 [DEBUG] Valid user data:', {
//             id: userData._id,
//             email: userData.email,
//             hasToken: !!userData.token
//         });

//         // 2️⃣ Pass validated data to loginOps
//         if (loginOps.handleSamlLogin) {
//             console.log('🔍 [DEBUG] Calling loginOps.handleSamlLogin');
//             await loginOps.handleSamlLogin(userData);

//             console.log('✅ [DEBUG] SAML login finished, useEffect will redirect');
//         } else {
//             console.error('❌ [DEBUG] loginOps.handleSamlLogin DOES NOT EXIST');
//         }

//     } catch (error) {
//         console.error('❌ [DEBUG] Error in handleSAMLUserLogin:', error);
//     }
// };


//     // TEST FUNCTIONS - TEMPORARY
//     const testManualSAML = async () => {
//         console.log('🧪 [TEST] Manual SAML test with ID:', testUserId);
//         await processSAMLUserLogin(testUserId);
//     }

//     const testURLSimulation = () => {
//         console.log('🧪 [TEST] Simulating SAML redirect URL');
//         history.push(`/dashboard/${testUserId}`);
//     }

//     // ALL YOUR EXISTING CODE BELOW REMAINS THE SAME
//     const emailInput = React.createRef()
//     const passInput = React.createRef()

//     useEffect(() => {
//         console.log('🔍 [DEBUG] Adding login class to body');
//         document.body.classList.add("login")
//         return () => {
//             console.log('🔍 [DEBUG] Removing login class from body');
//             document.body.classList.remove("login")
//         }
//     })

//     const tryWithoutLogin = () => {
//         console.log('🔍 [DEBUG] Try without login clicked');
//         headerOps.setFreeActivityHeader()
//         history.push("/free-activity")
//     }

//     const googleAuthLogin = useGoogleLogin({
//         onSuccess: async respose => {
//             console.log('🔍 [DEBUG] Google login success');
//             try {
//                 const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
//                     headers: {
//                         "Authorization": `Bearer ${respose.access_token}`
//                     }
//                 })
//                 if(res.data.email_verified){
//                     console.log('🔍 [DEBUG] Google email verified, logging in');
//                     loginOps.loginUserGoogle(res.data.email)
//                 }
//                 else{
//                     console.error('❌ [DEBUG] Google email not verified');
//                     props.toastSuccess("Error during Google signIn/Out, please try again")
//                 }
//             } catch (err) {
//                 console.error('❌ [DEBUG] Google login error:', err);
//                 props.toastSuccess("Error during Google signIn/Out, please try again")
//             }
//         }
//     });

//     function handleLoginClick() {
//         console.log('🔍 [DEBUG] Regular login clicked');
//         loginOps.loginUser(emailInput.current.value, passInput.current.value)
//     }

//     function onClickCreateAccount() {
//         console.log('🔍 [DEBUG] Create account clicked');
//         window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true","_blank")
//     }

//     function onClickForgotPassword() {
//         console.log('🔍 [DEBUG] Forgot password clicked');
//         history.push("/forget-password")
//     }

//     useEffect(() => {
//         console.log('🔍 [DEBUG] Checking version for cache burst');
//         async function fetchVersion() {
//             const cacheBurst = new Date().getTime()
//             let result = await fetch(`${process.env.PUBLIC_URL}/meta.json?`+cacheBurst)
//             result = await result.json()
//             const oldVersion = packageInfo.version
//             const newVersion = result.version
//             if(oldVersion !== newVersion) {
//                 console.log('🔍 [DEBUG] Version changed, emptying cache');
//                 props.set_appVersion(result.version)
//                 emptyCache()
//             }
//         }
//         fetchVersion().then()
//     }, [])

//     return (
//         <>
//             <header id="home-section">
//                 <div className="container-fluid h-100">
//                     <div className="row h-100">
//                         <div className="col-lg-8 p-0 text-white cover_img" style={{backgroundImage:'url('+process.env.PUBLIC_URL + '/assets/images/web/geometric-1732847_960_720.webp)'}}>
//                             <div className="dark-overlay d-flex flex-column align-items-center justify-content-center">
//                                 <h1 className="display-4 my-5 mont_txt">AI Connect</h1>
                                
//                                 <div id="slider4" className="container carousel slide mb-5" data-ride="carousel">
//                                     {/* ... your existing carousel content ... */}
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col-lg-4 d-flex flex-column align-items-center justify-content-center"
//                              style={{backgroundColor: "White" }}>
                            
//                             <img
//                                 id="com_logo"
//                                 src={process.env.PUBLIC_URL + '/assets/images/web/stemrobo_logo.png'}
//                                 className="img-fluid mt-5 mb-3"
//                                 style={{ width: '280px', height: 'auto' }}
//                                 alt={"stemrobo_logo"}
//                             />

//                             {/* TEMPORARY TEST SECTION - REMOVE AFTER TESTING */}
//                             <div className="bg-light p-3 mb-3 rounded" style={{border: '2px dashed #ffc107'}}>
//                                 <h5 className="text-center text-warning">🧪 SAML TEST</h5>
//                                 <div className="input-group mb-2">
//                                     <input 
//                                         type="text" 
//                                         className="form-control" 
//                                         placeholder="User ID"
//                                         value={testUserId}
//                                         onChange={(e) => setTestUserId(e.target.value)}
//                                     />
//                                 </div>
//                                 <div className="d-flex gap-2">
//                                     <button 
//                                         className="btn btn-warning btn-sm flex-fill" 
//                                         onClick={testManualSAML}
//                                     >
//                                         Test Manual Login
//                                     </button>
//                                     <button 
//                                         className="btn btn-info btn-sm flex-fill" 
//                                         onClick={testURLSimulation}
//                                     >
//                                         Test URL Redirect
//                                     </button>
//                                 </div>
//                             </div>

//                             <form>
//                                 <h3 className="text-center ai_h2 my-5">Login to Continue</h3>
                                
//                                 {/* YOUR EXISTING LOGIN FORM */}
//                                 <div className="input-group mb-3">
//                                     <div className="input-group-prepend">
//                                         <span className="input-group-text">@</span>
//                                     </div>
//                                     <input className="form-control mont_input1" name="email" type="email"
//                                            maxLength="150"
//                                            placeholder="Email-Id"
//                                            ref={emailInput}
//                                     />
//                                 </div>

//                                 <div className="input-group mb-3">
//                                     <div className="input-group-prepend">
//                                         <span className="input-group-text"><i className="fa fa-lock" /> </span>
//                                     </div>
//                                     <input className="form-control mont_input1" name="password" type="password"
//                                            maxLength="50"
//                                            placeholder="Password"
//                                            ref={passInput}
//                                     />
//                                 </div>
                                
//                                 <div className="d-flex px-3">
//                                     <div className="checkbox mr-auto invisible"></div>
//                                     <span id="frgt_pass" onClick={onClickForgotPassword} className="btn-link mont_txt txt_sm" style={{cursor: "pointer"}}>Forget Password?</span>
//                                 </div>

//                                 <div className="btn-toolbar justify-content-between" role="toolbar"
//                                      aria-label="Toolbar with button groups">
//                                     <div className="btn-group" role="group" aria-label="First group">
//                                         <div className="d-flex justify-content-around-1 my-4">
//                                             <button id="btn_login" className="bt1 btn btn-primary" type="button" onClick={handleLoginClick}>Login</button>
//                                         </div>
//                                     </div>
//                                     <div className="input-group">
//                                         <div className="d-flex justify-content-around my-4">
//                                             <button id="btn_login" style={{'background-color':'green','color':'white'}} className="bt1 btn btn-light" type="button" onClick={onClickCreateAccount}>Request a Callback</button>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div class="hr-div">
//                                     <hr class="hr-two-divider" style={{"margin": "24px 0px"}}></hr>
//                                     <div class="hr-middle-text">or</div>
//                                     <hr class="hr-two-divider" style={{"margin": "24px 0px"}}></hr>
//                                 </div>

//                                 {/* Google Login */}
//                                 <div className="d-flex justify-content-around my-3">
//                                     <button id="btn_google_login" className="bt1 btn btn-primary btn-transparent" type="button" onClick={googleAuthLogin}>
//                                     <img style={{height: "1.5rem", marginBottom: "0.2rem"}} src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'}/>  Continue with google
//                                     </button>
//                                 </div>
//                                 <hr /> 
//                             </form>
//                             <br/>
//                             <Link onClick={tryWithoutLogin} className="mb-5">Try without login &rarr;</Link>
//                         </div>
//                     </div>
//                 </div>
//             </header>
//         </>
//     )
// }













import React, {useEffect, useState} from 'react'
import './css/LoginPage.css'
import {Link, useHistory, useLocation} from "react-router-dom";
import useLoginOps from "../hooks/useLoginOps";
import useHeaderOps from "../hooks/useHeaderOps";
import {emptyCache} from "../../lib/js/jsUtil";
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import packageInfo from "../../../package.json";

export default function LoginPage(props) {
    const history = useHistory()
    const location = useLocation()
    const loginOps = useLoginOps(props)
    const headerOps = useHeaderOps(props)
    // Prevent SAML redirect loops
const [samlProcessed, setSamlProcessed] = useState(false);


    // SAML handling - runs on every location change
    // useEffect(() => {
    //     console.log('🔍 [DEBUG] Location changed:', location.pathname);
    //     console.log('🔍 [DEBUG] Full URL:', window.location.href);
    //     handleSAMLRedirect();
    // }, [location.pathname]);


    useEffect(() => {
    if (!samlProcessed) {
        handleSAMLRedirect();
    }
}, [location.pathname, samlProcessed]);


    // AUTO LOGIN WHEN URL HAS USER ID
    // const handleSAMLRedirect = async () => {
    //     const currentPath = window.location.pathname;
    //     console.log('🔍 [AUTO SAML] Checking path:', currentPath);

    //     // If already logged in → do nothing
    //     if (props.loginDetails !== null) return;

    //     // Check for /dashboard/<userid>
    //     if (currentPath.startsWith("/dashboard/")) {
    //         const userId = extractUserIdFromPath(currentPath);

    //         if (userId) {
    //             console.log("🚀 [AUTO SAML] Detected user ID:", userId);
    //             await processSAMLUserLogin(userId);
    //         } else {
    //             console.log("❌ [AUTO SAML] User ID invalid or missing");
    //         }
    //     }
    // };


    const handleSAMLRedirect = async () => {
    if (samlProcessed) return;  // ⛔ Prevent reprocessing

    const currentPath = window.location.pathname;
    // console.log('🔍 [AUTO SAML] Checking path:', currentPath);

    // Prevent interfering with normal login dashboard redirect
    if (currentPath === "/dashboard") return;

    // Already logged in → do nothing
    if (props.loginDetails !== null) return;

    // Only handle /dashboard/<userid>
    if (currentPath.startsWith("/dashboard/")) {
        const userId = extractUserIdFromPath(currentPath);

        if (userId) {
            // console.log("🚀 [AUTO SAML] Detected user ID:", userId);
            setSamlProcessed(true); // ⭐ VERY IMPORTANT
            await processSAMLUserLogin(userId);
        } else {
            // console.log("❌ [AUTO SAML] Invalid or missing user ID");
        }
    }
};



    // Extract user ID from path
    const extractUserIdFromPath = (path) => {
        // console.log('🔍 Extracting ID from:', path);

        const parts = path.split('/');
        if (parts.length >= 3 && parts[1] === "dashboard") {
            const userId = parts[2];
            if (/^[0-9a-fA-F]{24}$/.test(userId)) {
                return userId;
            }
        }
        return null;
    };


    // Call backend verify API
    const processSAMLUserLogin = async (userId) => {
        try {
            // console.log('🚀 [DEBUG] Calling SAML Verify API with:', userId);

            const response = await fetch('https://aiconnect.cc:35878/restapi/verifySamlToken', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: userId })
            });

            // console.log('🔍 API Status:', response.status);

            if (!response.ok) {
                throw new Error(`API returned status: ${response.status}`);
            }

            const data = await response.json();
            // console.log('🔍 Full response:', data);

            if (data.is_loggedin === true && data.user && data.user.token) {
                // console.log('✅ SAML verified successfully');
                await handleSAMLUserLogin(data.user);
            } else {
                throw new Error('Missing or invalid user data');
            }

        } catch (err) {
            // console.error('❌ SAML login failed:', err);
            props.toastSuccess("SSO Login failed. Please try again.");
        }
    };


    // Final step: login user into frontend
    const handleSAMLUserLogin = async (userData) => {
        try {
            // console.log('🔍 Finalizing SAML Login:', userData);

            if (!userData || !userData.token || !userData._id || !userData.email) {
                // console.error("❌ Invalid SAML user data");
                return;
            }

            if (loginOps.handleSamlLogin) {
                // await loginOps.handleSamlLogin(userData);

                await loginOps.handleSamlLogin(userData);
setSamlProcessed(true);   // ⭐ prevents redirect loops

                // console.log("✅ SAML login finished");
            } else {
                // console.error("❌ loginOps.handleSamlLogin missing");
            }

        } catch (err) {
            // console.error('❌ Error in final SAML login:', err);
        }
    };


    

    // EXISTING LOGIN LOGIC
    useEffect(() => {
        if (props.loginDetails !== null) {
            if (props.userProjects === null) {
                loginOps.fetchProjectsAndActivities()
            } else {
                history.push("/dashboard")
            }
        }
    }, [props.loginDetails, props.userProjects])


    const emailInput = React.createRef()
    const passInput = React.createRef()


    useEffect(() => {
        document.body.classList.add("login")
        return () => document.body.classList.remove("login")
    }, [])


    const tryWithoutLogin = () => {
        headerOps.setFreeActivityHeader()
        history.push("/free-activity")
    }


    const googleAuthLogin = useGoogleLogin({
        onSuccess: async respose => {
            try {
                const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
                    headers: {
                        "Authorization": `Bearer ${respose.access_token}`
                    }
                })
                if(res.data.email_verified){
                    loginOps.loginUserGoogle(res.data.email)
                }
                else{
                    props.toastSuccess("Error during Google login")
                }
            } catch (err) {
                props.toastSuccess("Error during Google login")
            }
        }
    });


    function handleLoginClick() {
        loginOps.loginUser(emailInput.current.value, passInput.current.value)
    }

    function onClickCreateAccount() {
        window.open(
            "https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true",
            "_blank"
        )
    }

    function onClickForgotPassword() {
        history.push("/forget-password")
    }


    useEffect(() => {
        async function fetchVersion() {
            const cacheBurst = new Date().getTime()
            let result = await fetch(`${process.env.PUBLIC_URL}/meta.json?`+cacheBurst)
            result = await result.json()
            const oldVersion = packageInfo.version
            const newVersion = result.version
            if(oldVersion !== newVersion) {
                props.set_appVersion(result.version)
                emptyCache()
            }
        }
        fetchVersion()
    }, [])


    return (
        // <>
        //     <header id="home-section">
        //         <div className="container-fluid h-100">
        //             <div className="row h-100">
                        
        //                 {/* LEFT SIDE IMAGE */}
        //                 <div className="col-lg-8 p-0 text-white cover_img"
        //                      style={{backgroundImage:'url('+process.env.PUBLIC_URL + '/assets/images/web/geometric-1732847_960_720.webp)'}}>
        //                     <div className="dark-overlay d-flex flex-column align-items-center justify-content-center">
        //                         <h1 className="display-4 my-5 mont_txt">AI Connect</h1>
        //                     </div>
        //                 </div>


         <>
        <header id="home-section">
            <div className="container-fluid h-100">
                <div className="row h-100">

                    {/* LEFT SIDE WITH BACKGROUND + CAROUSEL */}
                    <div className="col-lg-8 p-0 text-white cover_img"
                         style={{backgroundImage:'url('+process.env.PUBLIC_URL + '/assets/images/web/geometric-1732847_960_720.webp)'}}>

                        <div className="dark-overlay d-flex flex-column align-items-center justify-content-center">
                            <h1 className="display-4 my-5 mont_txt">AI Connect</h1>

                            {/* ⭐ FULL CAROUSEL ADDED HERE – UNTOUCHED ⭐ */}
                            <div id="slider4" className="container carousel slide mb-5" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    <li className="active" data-target="#slider4" data-slide-to="0"/>
                                    <li data-target="#slider4" data-slide-to="1"/>
                                    <li data-target="#slider4" data-slide-to="2"/>
                                    <li data-target="#slider4" data-slide-to="3"/>
                                </ol>

                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <div className="row justify-content-center">
                                            <div className="col-md-6">
                                                <h2 className="title2 mb-5 text-center poppins_txt">Graphics Designing</h2>
                                                <ul className="desc2 p-3 mt-3 ml-3 poppins_txt">
                                                    <li>Block based coding to learn Graphics Designing.</li>
                                                    <li>Learn Block Coding & Python Coding.</li>
                                                    <li>50 + Graphics Designing Activities, more than 25 + Projects.</li>
                                                    <li>Draw your Imaginations & learn coding.</li>
                                                    <li>Think Out of the box & draw your own graphics.</li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4 d-flex">
                                                <img className="img-fluid py-3 w-75 m-auto"
                                                     src={process.env.PUBLIC_URL + '/assets/images/web/Graphics_Designing.png'}
                                                     alt="Graphics_Designing"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="carousel-item">
                                        <div className="row justify-content-center">
                                            <div className="col-md-6">
                                                <h2 className="title2 mb-5 text-center poppins_txt">Basic Python</h2>
                                                <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
                                                    <li>GUI based coding to learn Python Coding.</li>
                                                    <li>Learn Block Coding & Python Coding.</li>
                                                    <li>100 + Basic Python Activities, more than 50 + Projects.</li>
                                                    <li>Draw your Imaginations & learn coding.</li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4 d-flex">
                                                <img className="img-fluid py-3 w-75 m-auto"
                                                     src={process.env.PUBLIC_URL + '/assets/images/web/Basic_Python.png'}
                                                     alt="Basic_Python"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="carousel-item">
                                        <div className="row justify-content-center">
                                            <div className="col-md-6">
                                                <h2 className="title2 mb-5 text-center poppins_txt">Machine Learning</h2>
                                                <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
                                                    <li>Train your own machine.</li>
                                                    <li>Test & Develop cases for your machine.</li>
                                                    <li>Deploy your own predictive learning.</li>
                                                    <li>Learn Block Coding & Python Coding.</li>
                                                    <li>50 + Machine Learning projects.</li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4 d-flex">
                                                <img className="img-fluid py-3 w-75 m-auto"
                                                     src={process.env.PUBLIC_URL + '/assets/images/web/Machine_Learning.png'}
                                                     alt="Machine_Learning"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="carousel-item">
                                        <div className="row justify-content-center">
                                            <div className="col-md-6">
                                                <h2 className="title2 mb-5 text-center poppins_txt">AI Real World</h2>
                                                <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
                                                    <li>Learn to detect & recognize human faces.</li>
                                                    <li>Learn to recognize objects.</li>
                                                    <li>Learn to recognize color & many more.</li>
                                                    <li>Integration of AI with hardware.</li>
                                                    <li>50 + Artificial Intelligence projects.</li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4 d-flex">
                                                <img className="img-fluid py-3 w-75 m-auto"
                                                     src={process.env.PUBLIC_URL + '/assets/images/web/AI_Real_World.png'}
                                                     alt="AI_Real_World"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <a href="#slider4" className="carousel-control-prev" data-slide="prev">
                                    <span className="carousel-control-prev-icon"/>
                                </a>

                                <a href="#slider4" className="carousel-control-next" data-slide="next">
                                    <span className="carousel-control-next-icon"/>
                                </a>
                            </div>
                           
                        </div>
                    </div>


                        {/* RIGHT SIDE LOGIN */}
                        <div className="col-lg-4 d-flex flex-column align-items-center justify-content-center"
                             style={{backgroundColor: "White" }}>

                            <img
                                id="com_logo"
                                src={process.env.PUBLIC_URL + '/assets/images/web/stemrobo_logo.png'}
                                className="img-fluid mt-5 mb-3"
                                style={{ width: '280px', height: 'auto' }}
                                alt="stemrobo_logo"
                            />

                            {/* LOGIN FORM */}
                            <form>
                                <h3 className="text-center ai_h2 my-5">Login to Continue</h3>

                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">@</span>
                                    </div>
                                    <input className="form-control mont_input1" name="email" type="email"
                                           maxLength="150" placeholder="Email-Id" ref={emailInput}/>
                                </div>

                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"><i className="fa fa-lock" /></span>
                                    </div>
                                    <input className="form-control mont_input1" name="password" type="password"
                                           maxLength="50" placeholder="Password" ref={passInput}/>
                                </div>

                                <div className="d-flex px-3">
                                    <span id="frgt_pass" onClick={onClickForgotPassword}
                                          className="btn-link mont_txt txt_sm" style={{cursor: "pointer"}}>
                                        Forget Password?
                                    </span>
                                </div>

                                <div className="btn-toolbar justify-content-between">
                                    <div className="btn-group">
                                        <button id="btn_login" className="bt1 btn btn-primary my-4" type="button"
                                                onClick={handleLoginClick}>Login</button>
                                    </div>

                                    <div className="btn-group">
                                        <button id="btn_login" style={{backgroundColor:'green',color:'white'}}
                                                className="bt1 btn btn-light my-4" type="button"
                                                onClick={onClickCreateAccount}>
                                            Request a Callback
                                        </button>
                                    </div>
                                </div>

                                <div className="hr-div">
                                    <hr className="hr-two-divider"/>
                                    <div className="hr-middle-text">or</div>
                                    <hr className="hr-two-divider"/>
                                </div>

                                <div className="d-flex justify-content-around my-3">
                                    <button id="btn_google_login" className="bt1 btn btn-primary btn-transparent"
                                            type="button" onClick={googleAuthLogin}>
                                        <img style={{height: "1.5rem", marginBottom: "0.2rem"}}
                                             src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'} />  
                                        Continue with Google
                                    </button>
                                </div>
                            </form>

                            <br/>
                            {/* <Link onClick={tryWithoutLogin} className="mb-5">Try without login →</Link> */}

                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}






